export default "__VITE_ASSET__ff34a787__"